// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 00:08:23

export default {
  "id": "rush-car-driving-race-master",
  "slug": "rush-car-driving-race-master",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/e5fb999a4e014f44b08edf59caea9d4f-512x384.jpeg",
  "gameUrl": "https://html5.gamedistribution.com/e5fb999a4e014f44b08edf59caea9d4f/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Rush Car Driving - Race Master",
      "description": "Rush Car Driving: Race Master is a driving game that delivers thrilling action as you navigate heavy traffic. \n\nExperience the adrenaline of high-speed racing in heavy traffic, where split-second decisions can be the difference between victory and defeat. Explore a variety of immersive environments, from busy urban highways to rural roads. \n\nChoose from a wide selection of cars, from sports cars to muscle machines. Buckle up and start the race!",
      "instructions": "Use the left mouse button to move between lanes.\n\nEarn coins to buy new cars or upgrade existing ones.",
      "genres": [
        "Casual",
        "Racing & Driving"
      ],
      "tags": [
        "3d",
        "car",
        "physics",
        "rider",
        "vehicle"
      ]
    },
    "zh-CN": {
      "title": "疯狂赛车 - 赛车大师",
      "description": "疯狂赛车：速度大师是一款让你在拥堵的交通中驾驶的赛车游戏。\n\n体验在拥堵的交通中高速竞速的肾上腺素刺激，每一秒的决定都可能是胜利与失败的区别。探索多样化的沉浸式环境，从繁忙的城市高速公路到乡村道路。\n\n从众多选择中选择一辆赛车，从跑车到肌肉车。系好安全带，开始比赛吧！",
      "instructions": "使用左鼠标按钮在车道间移动。\n\n赚取金币来购买新车或升级现有车型。",
      "genres": [
        "休闲",
        "赛车与驾驶"
      ],
      "tags": [
        "三维",
        "汽车",
        "物理",
        "骑手",
        "车辆"
      ]
    },
    "zh-TW": {
      "title": "衝刺車輛駕駛 - 賽車大師",
      "description": "Rush Car Driving: 賽車大師是一款帶給您刺激冒險的駕駛遊戲，讓您在擁擠的交通中穿梭。\n\n體驗在擁擠交通中高速競賽的興奮，每一秒的決策都可能決定勝敗。探索多種沉浸式環境，從繁忙的城市高速公路到鄉村道路。\n\n從各種選擇中選擇您的愛車，從跑車到肌肉車。系上安全帶，開始賽車吧！",
      "instructions": "使用左鍵鼠標在車道間移動。\n\n獲得硬幣以購買新車或升級現有車輛。",
      "genres": [
        "休閒",
        "賽車與駕駛"
      ],
      "tags": [
        "3D",
        "車輛",
        "物理",
        "騎手",
        "車輛"
      ]
    },
    "zh-HK": {
      "title": "衝刺車輛駕駛 - 賽車大師",
      "description": "Rush Car Driving: 賽車大師是一款能讓您在擁擠車流中體驗刺激行動的駕駛遊戲。\n\n在擁擠車流中享受高速賽車的 adrenaline，分鐘決勝，一念之間即可決定勝敗。探索各種沉浸式環境，從繁忙的都市高速公路到鄉村道路。\n\n從多款選擇中選擇您心儀的車輛，從跑車到肌肉車。綁好安全帶，開始賽車吧！",
      "instructions": "使用左鍵鼠標移動之間的車道。\n\n earn coins to buy new cars or upgrade existing ones.",
      "genres": [
        "輕鬆",
        "賽車與駕駛"
      ],
      "tags": [
        "3D",
        "車輛",
        "物理",
        "騎手",
        "車輛"
      ]
    },
    "ja": {
      "title": "ラッシュ・カー・ドライビング - レース・マスター",
      "description": "ラッシュ・カー・ドライビング：レース・マスターは、混雑した交通を進む中で心躍るアクションを提供するドライビングゲームです。\n\n混雑した交通の中での高速レースのアドレナリンを体験し、瞬時の決断が勝敗の分かれ目になる様子を楽しみましょう。忙しい都市の高速道路から田舎の道まで、さまざまな没入感のある環境を探検してください。\n\nスポーツカーからマッスルカーまで、幅広い車種の中から選んでください。シートベルトを締めてレースを始めましょう！",
      "instructions": "左マウスボタンを使ってレーンを移動します。\n\nコインを集め、新しい車を購入したり、既存の車をアップグレードします。",
      "genres": [
        "カジュアル",
        "レーシング & ドライビング"
      ],
      "tags": [
        "3D",
        "車",
        "物理",
        "ライダー",
        "車両"
      ]
    },
    "ko": {
      "title": "빠른차 운전 - 레이스 마스터",
      "description": "Rush Car Driving: Race Master는 가득한 교통에서 신나는 행동을 제공하는 드라이빙 게임입니다.\n\n가득한 교통에서의 높은 속도 경주의 아드레날린을 체험해 보세요. 초단위의 결정이 승리와 패배의 차이가 될 수 있습니다. 도시 고속도로부터 농촌 도로까지 다양한 몰입형 환경을 탐험하세요.\n\n스포츠카에서 몸통차까지 다양한 차량 중에서 선택하세요. 안전벨트를 매어 경주를 시작하세요!",
      "instructions": "왼쪽 마우스 버튼을 사용하여는 레인을 이동합니다.\n\n코인을 모아 새로운 차를 구매하거나 기존 차량을 업그레이드하세요.",
      "genres": [
        "캐주얼",
        "레이싱 & 드라이빙"
      ],
      "tags": [
        "3D",
        "자동차",
        "물리학",
        "라이더",
        "차량"
      ]
    },
    "fr": {
      "title": "Course de voitures en déplacement rapide - Maître de Course",
      "description": "Rush Car Driving: Race Master est un jeu de conduite qui offre des actions palpitantes alors que vous vous faufiliez dans un trafic dense.\n\nExpérimentez l'adrénaline de la course à haute vitesse dans un trafic dense, où des décisions prises à la milliseconde près peuvent faire la différence entre la victoire et la défaite. Explorez une variété d'environnements immersifs, allant des autoroutes urbaines animées aux routes rurales.\n\nChoisissez parmi une large sélection de voitures, des voitures de sport aux machines de muscle. Mettez-vous en sécurité et démarrez la course !",
      "instructions": "Utilisez le bouton gauche de la souris pour vous déplacer entre les voies.\n\nGagnez des pièces pour acheter de nouveaux véhicules ou pour les améliorer.",
      "genres": [
        "Accordéon",
        "Course & Conduite"
      ],
      "tags": [
        "3D",
        "voiture",
        "physique",
        "cavalier",
        "véhicule"
      ]
    }
  }
};
